import { useEffect, useState, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false)
  const [atForm, setAtForm] = useState(false)
  const barRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setVisible(scrollY > 400)

      const formSection = document.getElementById('confianza')
      if (formSection) {
        const rect = formSection.getBoundingClientRect()
        setAtForm(rect.top < 100 && rect.bottom > 100)
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (barRef.current) {
      if (visible && !atForm) {
        gsap.fromTo(barRef.current, { y: 100 }, { y: 0, duration: 0.4, ease: 'power2.out' })
      } else {
        gsap.to(barRef.current, { y: 100, duration: 0.3, ease: 'power2.in' })
      }
    }
  }, [visible, atForm])

  const scrollToForm = () => {
    document.getElementById('confianza')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div
      ref={barRef}
      className="fixed bottom-0 left-0 w-full z-[90] md:block hidden"
      style={{
        backgroundColor: 'white',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
        borderTop: '1px solid #E5E7EB',
        transform: 'translateY(100%)',
      }}
    >
      <div className="container-main flex items-center justify-between py-4">
        <p className="font-semibold text-base" style={{ color: '#0F293E' }}>
          ¿Listo para transformar tu colegio?
        </p>
        <button
          onClick={scrollToForm}
          className="btn-primary"
          style={{ padding: '10px 24px', fontSize: '14px' }}
        >
          Solicitar Información
        </button>
      </div>
    </div>
  )
}

export default FloatingCTA
